import React from 'react';
import { Helmet } from 'react-helmet-async';

function PrivacyPolicy() {
  return (
    <div className="bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
       <Helmet>
              <title>Kota HOLDINGS</title>
              <meta name="description" content="A Vision of My 30-Year World" />
            </Helmet>
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
        <h1 className="text-2xl md:text-3xl font-bold text-[#FF6F00] mb-6 text-center">
          Privacy Policy
        </h1>
        <p className="text-gray-700 text-base leading-relaxed mb-4">
          Welcome to Kotha Holdings! We appreciate your trust in us and are committed to safeguarding your privacy. This Privacy Policy outlines how Ruloans ("we," "us," or "our") collects, uses, and shares your information when you access our website, mobile application (Kotha Holdings), or interact with our services.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">Information We Collect:</h2>
        <p className="text-gray-700 text-base leading-relaxed mb-4">
          At Kotha Holdings, we collect various types of information to provide and enhance our services. The information we collect may include:
        </p>
        <ul className="list-disc list-inside text-gray-700 text-base leading-relaxed mb-4">
          <li>
            <span className="font-semibold">Personal Information:</span> This comprises your name, contact details (such as phone numbers, email addresses, mailing addresses), date of birth, gender, contact preferences, authentication data, financial information (such as credit worthiness data, bank details), and any other information necessary for delivering our services.
          </li>
          <li>
            <span className="font-semibold">Device Information:</span> We may gather information about the devices you utilize to access our services, including device identifiers, IP address, browser type, operating system, and network information.
          </li>
          <li>
            <span className="font-semibold">Usage Data:</span> Information regarding how you interact with our services, such as the pages you visit, the features you utilize, the actions you perform, and other usage patterns.
          </li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">How We Use Your Information:</h2>
        <p className="text-gray-700 text-base leading-relaxed mb-4">
          We utilize the information we collect for various purposes, including:
        </p>
        <ul className="list-disc list-inside text-gray-700 text-base leading-relaxed mb-4">
          <li>Facilitating account creation and authentication on Kotha Holdings, delivering and managing our services, including loan-related activities such as loan application processing, eligibility assessment, and loan disbursal.</li>
          <li>Sending administrative and promotional communications, responding to your inquiries and requests, providing customer support, and notifying you about important updates or changes to our services.</li>
          <li>Tailoring your experience by delivering targeted advertising and personalized content based on your interests, preferences, and previous interactions with our services.</li>
          <li>Analyzing usage data to improve our services, identify trends, measure the effectiveness of our marketing campaigns, and enhance the user experience.</li>
          <li>Protecting the security of our services and preventing fraudulent activities, unauthorized access, or other harmful actions.</li>
          <li>Fulfilling legal obligations and regulatory requirements, such as anti-money laundering laws, consumer protection regulations, and data protection laws.</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">Grievance Redressal:</h2>
        <p className="text-gray-700 text-base leading-relaxed mb-4">
          If you have any questions, concerns, or grievances regarding this Privacy Policy or our data practices, please contact our Grievance Officer at:
        </p>
        <p className="text-gray-700 text-base leading-relaxed mb-4">
          <span className="font-semibold">Phone:</span>+91 7794875600 <br />
          <span className="font-semibold">Email:</span> venkatareddy.k@kotaholdings.in
        </p>
        <p className="text-gray-700 text-base leading-relaxed">
          <span className="font-semibold">Address:</span> KOTA HOLDINGS <br />Flat #2 & 3, Kota chambers <br></br> GK Towers, Dwarakanagar
          <br/> Visakhapatnam, Andhra Pradesh, 530016 </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;